export default {

  backgroundTransparency: {
    properties: {
      component: 'Transparency',
      type: "numeric",
      visible: 'enableBackground',
      displayName: "Transparency",
      description: null
    },
    value: 50
  },
  transparency: {
    properties: {
      component: 'Transparency',
      type: "numeric",
      displayName: "Transparency",
      description: "Set transparency for background color"
    },
    value: 20
  },

  maxBreakdowns: {
    properties: {
      component: 'IntegerComponent',
      type: "integer",
      displayName: "Max breakdowns",
      description: "The number of individual breakdowns to show (rest grouped into Other)"
    },
    value: 20
  },
  map: {
    properties: {
      component: 'GeoJson',
      type: "geoJson",
      displayName: "Map",
      description: null
    },
    value: null
  },
  indicatorPrecision: {
    properties: {
      component: 'IntegerComponent',
      type: "integer",
      displayName: "Value decimal places",
      description: "Select the number of decimal places to display for the values"
    },
    value: 20
  },


  image: {
    properties: {
      component: 'ImageComponent',
      type: "formatting",
      name: 'background',
      displayName: "Name",
      description: null
    },
    value: null
  },
  goalText: {
    properties: {
      component: 'TextComponent',
      type: "formatting",
      name: 'background',
      displayName: "Goal Text",
      description: null
    },
    value: null
  },
  name: {
    properties: {
      component: {
        name: 'TextComponent',
        globalStyles: 'TextComponent',
        stylePreset: 'Select',
        tableEx: 'Select',
      },
      type: "formatting",
      displayName: "Name",
      description: null
    },
    value: null
  },
  layerTitle: {
    properties: {
      component: 'TextComponent',
      type: "formatting",
      displayName: "Title",
      description: null
    },
    value: 'Layers'
  },
  titleText: {
    properties: {
      component: 'TextComponent',
      type: "formatting",
      visible: ['showMarker', 'showAxisTitle', 'showTitle'],
      displayName: "Title Text",
      description: null
    },
    value: null
  },
  text: {
    properties: {
      component: 'TextComponent',
      type: "formatting",
      displayName: "Text",
      description: null
    },
    value: null
  },
  secTitleText: {
    properties: {
      component: 'TextComponent',
      type: "formatting",
      visible: ['showMarker', 'showAxisTitle'],
      displayName: "Title Text",
      description: null
    },
    value: "Secondary Value Axis"
  },

  alignment: {
    properties: {
      component: 'AlignmentHorizontal',
      type: "enumeration",
      displayName: "Alignment",
      description: null
    },
    value: 'left'
  },
  horizontalAlignment: {
    properties: {
      component: 'AlignmentHorizontal',
      type: "enumeration",
      displayName: "Alignment",
      description: null
    },
    value: 'left'
  },
  titleAlignment: {
    properties: {
      component: 'AlignmentHorizontal',
      type: "enumeration",
      displayName: "Alignment",
      description: null
    },
    value: 'Right'
  },

  verticalAlignment: {
    properties: {
      component: 'AlignmentVertical',
      type: "enumeration",
      displayName: "Vertical alignment",
      description: null
    },
    value: 'Bottom'
  },

  fontSize: {
    properties: {
      component: 'TextSize',
      type: "formatting",
      displayName: "Text Size",
      description: null
    },
    value: null
  },
  titleFontSize: {
    properties: {
      component: 'TextSize',
      type: "formatting",
      visible: 'showAxisTitle',
      displayName: "Title text size",
      description: null
    },
    value: null
  },
  categoryLabelFontSize: {
    properties: {
      component: 'TextSize',
      type: "formatting",
      visible: 'showAxisTitle',
      displayName: "Label text size",
      description: null
    },
    value: 13
  },
  secFontSize: {
    properties: {
      component: 'TextSize',
      type: "formatting",
      displayName: "Title text size",
      description: null
    },
    value: null
  },
  secTitleFontSize: {
    properties: {
      component: 'TextSize',
      type: "formatting",
      displayName: "Title text size",
      description: null
    },
    value: null
  },
  null: {
    properties: {
      component: 'TextSize',
      type: "formatting",
      displayName: "Title text size",
      description: null
    },
    value: null
  },
  axisLabel: {
    properties: {
      component: 'NoneComponent',
      type: "none",
      displayName: "Y-Axis (Column)",
      description: null
    },
    value: false
  },
  $id: {
    properties: {
      component: 'NoneComponent',
      type: "none",
      displayName: "$id",
      description: null
    },
    value: false
  },
  secAxisLabel: {
    properties: {
      component: 'NoneComponent',
      type: "none",
      displayName: "Y-Axis (Line)",
      description: null
    },
    value: false
  },
  imageUrl: {
    properties: {
      component: 'ImageComponent',
      type: "enumeration",
      displayName: "Image",
      description: 'Upload image'
    },
    value: null
  },
}